export default __webpack_public_path__ + "static/media/Avatar-30.b5d2d6a7.svg";